import React from "react"
import TableContainer from "./Table/table"
import { StartDateactivity } from "pages/Reports/VerifyMyTeams/VerifyScreenCol"
import { EndTimess, StartTime } from "pages/Reports/VerifyScreens/VerifyScreenCol"
import TableAction from "./TableAction"

function InsideTable({
  data,
  isMobile,
  activeReportStatus,
  dateMatch,
  onClick,
  supervisorFilter,
  handleVerify,
  MultileScreen,
  toggleViewModal,
  MultileReports,
  handleApprove,
  handleReject,
})
{
  const insideColumns = React.useMemo(() => {
    const commonInitialColumn = {
      Header: " ",
      accessor: "  ",
      disableFilters: true,
      sort: false,
      hidden:
        (dateMatch && supervisorFilter?.id !== 4) ||
        (activeReportStatus?.id === 3 && supervisorFilter?.id === 3),
      width: isMobile && "",
      Cell: () => (
        <span className="bx bx-plus-circle font-size-18" style={{ opacity: 0 }} />
      ),
    };
      if (activeReportStatus?.id === 5 || activeReportStatus?.id === 6) {
        return [
        commonInitialColumn,
         {
          Header: "Employee Id",
          accessor: "empId",
          disableFilters: true,
          sort: true,
          hidden: dateMatch,
          Cell: () => <></>, 
          footerType: false,
          totalType: false,
          style: { minWidth: "70px" },
        },
        {
          Header: "Emp Name",
          accessor: "userName",
          disableFilters: true,
          sort: false,
          hidden: false,
          footerType: true,
          totalType: true,
          Cell: () => <></>, 
          style: {
              minWidth: "100px",
              textAlign: "start",
              maxWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
          },
      },
      {
          Header: "Client Name",
          accessor: "clientName",
          disableFilters: true,
          sort: true,
          hidden: dateMatch,
          Cell: cellProps => <>{cellProps.cell.value}</>,
          footerType: false,
          totalType: false,
          style: {
              minWidth: "140px",
              textAlign: "start",
              maxWidth: "140px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
          },
        },
        {
          Header: "Project Name",
          accessor: "projectName",
          disableFilters: true,
          sort: true,
          hidden: false,
          footerType: false,
          Cell: ({ cell: { value } }) => <span>{value}</span>,
          style: {
              minWidth: "140px",
              textAlign: "start",
              maxWidth: "140px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
          },
        },
        {
          Header: "Approved By",
          accessor: "approvedBy",
          disableFilters: true,
          sort: false,
          hidden: false,
          footerType: true,
          totalType: true,
          Cell: cellProps => <>{cellProps.cell.value}</>,
          style: {
              minWidth: "100px",
              textAlign: "start",
              maxWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
           }, 
        },
        {
          Header: "Date",
          accessor: "date",
          disableFilters: true,
          sort: true,
          hidden: dateMatch,
          Cell: !dateMatch ? (cellProps => <StartDateactivity {...cellProps} />) : undefined,
          footerType: false,
          totalType: false,
          style: {
              minWidth: "110px",
              width: "110px",
              textAlign: "start",
              whiteSpace: "nowrap",
        },
        },
         {
          Header: "Start Time",
          accessor: "startTime",
          disableFilters: true,
          sort: true,
          hidden: false,
          Cell: cellProps => <StartTime {...cellProps} />,
          style: {
              minWidth: "60px",
              textAlign: "start",
              maxWidth: "60px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
        },
        },
        {
          Header: "End Time",
          accessor: "endTime",
          disableFilters: true,
          sort: true,
          hidden: false,
          Cell: cellProps => <EndTimess {...cellProps} />,
          style: {
              minWidth: "60px",
              textAlign: "start",
              maxWidth: "60px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
        },
        },
        {
          Header: "Total Duration",
          accessor: "duration",
          disableFilters: true,
          sort: false,
          hidden: false,
          footerType: true,
          totalType: true,
          Cell: cellProps => <>{cellProps.cell.value}</>,
          style: {
              minWidth: "60px",
              textAlign: "start",
              maxWidth: "60px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
        },
        },
        {
          Header: "Comments",
          accessor: "comments",
          disableFilters: true,
          sort: false,
          hidden: false,
          footerType: true,
          totalType: true,
          Cell: cellProps => <>{cellProps.cell.value}</>,
          style: {
              minWidth: "150px",
              textAlign: "start",
              maxWidth: "250px",
              whiteSpace: "normal",
              overflow: "visible",
              wordBreak: "break-word",
          },
        },
        ...(activeReportStatus?.id === 6 ? [{
          Header: "Action",
          accessor: "action",
          disableFilters: true,
          sort: false,
          hidden: false,
          style: {
            minWidth: "160px",
            textAlign: "center",
          },
          Cell: cellProps => (
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-primary btn-sm me-2"
                onClick={(e) => {
                  e.stopPropagation();
                  handleApprove && handleApprove(cellProps.row.original);
                }}
              >
                Accept
              </button>
              <button
                type="button"
                className="btn btn-danger btn-sm"
                onClick={(e) => {
                  e.stopPropagation();
                  handleReject && handleReject(cellProps.row.original);
                }}
              >
                Reject
              </button>
            </div>
          ),
        }] : []),
      ];
    }
     return [
      commonInitialColumn,
      {
        Header: "Name",
        accessor: activeReportStatus?.id == 2 ? "clientName" : "user_name",
        disableFilters: true,
        sort: false,
        hidden: false,
        Footer: info => (
          <>
            {supervisorFilter?.id == 4 ||
              (activeReportStatus?.id !== 1 && (
                <strong className="d-flex justify-content-end">Total: </strong>
              ))}
          </>
        ),
        Cell: cellProps => {
          return activeReportStatus.id !== 1 ||
            (activeReportStatus?.id == 2 && !dateMatch) ? (
            <div
              style={{
                opacity:
                  (activeReportStatus?.id == 2 && !dateMatch) ||
                  supervisorFilter?.id == 4
                    ? 0
                    : 1,
                opacity: 0,
                minWidth: "330px",
                textAlign: "start",
                maxWidth: "330px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {cellProps.cell.value}
            </div>
          ) : (
            <span
              style={{
                opacity: 0,
                minWidth: "330px",
                textAlign: "start",
                maxWidth: "330px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              HR-R-00008
            </span>
          )
        },
        footerType: true,
        totalType: true,
        width: isMobile && "",
        style: {
          minWidth:
            activeReportStatus?.id == 2
              ? "299px"
              : supervisorFilter?.id == 4
              ? "160px"
              : "300px",
          textAlign: "start",
          maxWidth:
            activeReportStatus?.id == 2
              ? "299px"
              : supervisorFilter?.id == 4
              ? "160px"
              : "300px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      {
        Header: "Project Name",
        accessor: "projectName",
        disableFilters: true,
        style: {
          minWidth: activeReportStatus?.id == 2 ? "300px" : "160px",
          textAlign: "start",
          maxWidth: activeReportStatus?.id == 2 ? "300px" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        sort: true,
        hidden:
          supervisorFilter.id == 4 || activeReportStatus?.id == 2 || activeReportStatus?.id == 5
            ? false
            : true,
        footerType: false,
        Cell: ({ cell: { value } }) => {
          return activeReportStatus.id !== 2  ? <span>{value}</span> : null;
        },
      },
      {
        Header: "Project Head",
        accessor: "headName",
        disableFilters: true,
        sort: true,
        hidden: supervisorFilter.id == 4 ? false : true,
        footerType: true,
        totalType: true,
        style: {
          minWidth: "150px",
          textAlign: "start",
          maxWidth: "150px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        Cell: cellProps => {
          return dateMatch && supervisorFilter.id == 4 && !dateMatch ? (
            <span style={{ opacity: 0 }}>Sankaranarayanan B</span>
          ) : (
            <>{cellProps?.cell.value}</>
          )
        },
      },
      {
        Header: "Reporting Lead",
        accessor: "reportingLead",
        disableFilters: true,
        sort: true,
        hidden: supervisorFilter.id == 4 ? false : true,
        Cell: cellProps => {
          return <>{cellProps.cell.value}</>
        },
        style: {
          minWidth: "130px",
          textAlign: "start",
          maxWidth: "130px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      {
        Header: "Employee Id",
        accessor: "empId",
        disableFilters: true,
        sort: true,
        hidden: false,
        footerType: false,
        totalType: false,
        style: {
          minWidth: supervisorFilter.id !== 4 ? "130px" : "70px",
        },
        Cell: cellProps => {
          return activeReportStatus.id === 2 || supervisorFilter.id === 4 ? (
            <>{cellProps.cell.value}</>
          ) : (
            <span style={{ opacity: 0 }}>HR-R-00008</span>
          )
        },
      },
      {
        Header: "Employee Name",
        accessor: "employeeName",
        disableFilters: true,
        sort: false,
        hidden:
          (activeReportStatus?.id == 2 && !dateMatch) ||
          supervisorFilter?.id == 4
            ? false
            : true,
        footerType: true,
        totalType: true,
        Cell: cellProps => {
          return (activeReportStatus?.id == 2 && !dateMatch) ||
            supervisorFilter?.id === 4 ? (
            <>{cellProps.cell.value}</>
          ) : (
            <span style={{ opacity: 0 }}>HR-R-00008</span>
          )
        },
        style: {
          minWidth: "200px",
          textAlign: "start",
          maxWidth: "200px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      {
        Header: "Date",
        accessor: "date",
        disableFilters: true,
        sort: true,
        hidden: activeReportStatus.id !== 1 || (dateMatch && true),
        Cell: cellProps => {
          return !dateMatch ? (
            <StartDateactivity {...cellProps} />
          ) : (
            <span style={{ opacity: 0 }}>2023-08-10</span>
          )
        },
        footerType: false,
        totalType: false,
        style: {
          minWidth: "90px",
        },
      },

      {
        Header: "Start Time",
        accessor: "startTime",
        disableFilters: true,
        sort: true,
        hidden: !(activeReportStatus.id === 1),
        Cell: cellProps => {
          return <StartTime {...cellProps} />
        },
        footerType: false,
        totalType: false,
        style: {
          minWidth: "80px",
        },
      },
      {
        Header: "End Time",
        accessor: "endTime",
        disableFilters: true,
        sort: true,
        hidden: !(activeReportStatus.id === 1),
        Cell: cellProps => {
          return <StartTime {...cellProps} />
        },
        Footer: info => (
          <>
            <strong className="d-flex justify-content-end">Total: </strong>
          </>
        ),
        footerType: true,
        totalType: true,
        width: isMobile && "",
      },
      {
        Header: "Total Hours",
        accessor: "totalHours",
        disableFilters: true,
        sort: true,
        hidden: false,
        sortEnable: false,
        Footer: info => (
          <>
            <span className="d-flex justify-content-start text-primary">
              {sumofIdleHours("totalHours", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
      },
      {
        Header: "Billable Hours",
        accessor: "clientHours",
        disableFilters: true,
        sort: true,
        hidden: supervisorFilter.id !== 4 ? false : true,

        Footer: info => (
          <>
            <span className="d-flex justify-content-start">
              {sumofIdleHours("clientHours", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
        width: isMobile && "",
      },
      {
        Header: "Non-Billable Hours",
        accessor: "internalHours",
        disableFilters: true,
        sort: true,
        hidden: supervisorFilter.id !== 4 ? false : true,

        Footer: info => (
          <>
            <span className="d-flex justify-content-start">
              {sumofIdleHours("internalHours", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
        width: isMobile && "",
      },
      {
        Header: "Leave Hours",
        accessor: "leavehours",
        disableFilters: true,
        sort: true,
        hidden: supervisorFilter.id !== 4 ? false : true,
        Footer: info => (
          <>
            <span className="d-flex justify-content-start">
              {sumofIdleHours("leavehours", hoursReportList)}
            </span>
          </>
        ),
        footerType: true,
        totalType: false,
        width: isMobile && "",
      },

      {
        Header: "Action",
        sort: false,
        style: {
          minWidth: "80px",
        },
        Cell: cellProps => (
          <div
            role="button"
            style={{ cursor: "pointer" }}
            className="verify-screen-button"
          >
            {/* <TableAction
              handleOnExpand={handleOnExpand}
              handleVerify={
                supervisorFilter?.id == 4 ? MultileScreen : handleVerify
              }
              cellProps={cellProps}
            /> */}

            {supervisorFilter?.id == 4 ? (
              <TableAction
                handleOnExpand={dateMatch ? toggleViewModal : MultileReports}
                handleVerify={dateMatch ? handleVerify : MultileScreen}
                cellProps={cellProps}
              />
            ) : (
              <>
                <TableAction
                  handleOnExpand={!dateMatch ? toggleViewModal : MultileReports}
                  handleVerify={!dateMatch ? handleVerify : MultileScreen}
                  cellProps={cellProps}
                />
              </>
            )}
          </div>
        ),
      },
    ]
    return result
  }, [activeReportStatus, supervisorFilter, isMobile, dateMatch])
    
  

  return (
    <TableContainer
      columns={insideColumns}
      data={data}
      footeraddition={false}
      tableHeader="hide"
      onClick={onClick}
    />
  );
}

export default InsideTable
